import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    questionnaireContainer: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    questionnaireItem: {
        width: '100%',
        marginBottom: theme.spacing(1),
    },
    questionnaireItemHeader: {
        width: '100%',
        height: '40px',
        textAlign: 'left',
        color: 'white',
        fontSize: 18,
        fontWeight: 'bold',
        backgroundColor: theme.palette.secondary.light,
        display: 'flex',
        justifyContent: 'space-between',
        borderRadius: '4px',
    },
    formControl: {
        marginTop: theme.spacing(2)
    },
    appSelectGridItem: {
         marginTop: theme.spacing(2)
    },
    treatmentItemHeader: {
        width: '100%',
        height: '40px',
        textAlign: 'left',
        fontSize: 18,
        fontWeight: 'bold',
        display: 'flex',
        justifyContent: 'space-between',
        borderRadius: '4px',
    },
    formLabelStyle: {
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: '1.25rem',
        marginTop: theme.spacing(2)
    },
    accordionMarginStyle: {
        margin: '0px'
    },
    gridItemMarginStyle: {
        marginTop: theme.spacing(2)
    }
}));

export default useStyles;
